import React from 'react';
import { Button } from 'antd';
import i18n from '../i18n';
import {connect} from 'react-redux';
import Menutest from './menu.js';
import Modal from 'react-modal';
import Carousel from '@brainhubeu/react-carousel';
import { Icon} from 'antd';
import axios from 'axios';

import {reactLocalStorage} from 'reactjs-localstorage';
import { API_BASE_URL } from "../utils/endpoints";


const customStyles = {
    content : {
      left                  : '11%',
      right                 : 'auto',
      bottom                : 'auto',
      marginRight           : '-50%',
     
    }
  };
class Landing extends React.Component {
    constructor() {
      super();
  
      this.state = {
        modalIsOpen: false,
        show:false,
        collapsed: false,
         collapseID : '',
         image:[]
         
        
      };
  
      this.openModal = this.openModal.bind(this);
      this.afterOpenModal = this.afterOpenModal.bind(this);
      this.closeModal = this.closeModal.bind(this);
    }
  
    openModal() {
      this.setState({modalIsOpen: true});
    }
  
    afterOpenModal() {
      // references are now sync'd and can be accessed.
      this.subtitle.style.color = '#f00';
    }
  
    closeModal() {
      this.setState({modalIsOpen: false});
    }
    componentDidMount(){
      
    /*if(reactLocalStorage.get('lang') === 'ar')
    {
      i18n.changeLanguage('ar');
      document.querySelector('.big_div').style = 'direction: rtl;';
    }
    else{
      i18n.changeLanguage('en');
    }*/

        this.setState({modalIsOpen: true});
        
            var token=reactLocalStorage.get('accessToken');
            if(token === undefined)
            {
              window.location="app"
            }
          


               var ip=API_BASE_URL;
               var s2 = "localhost:3000";
               var apiBaseUrl;
               if(ip.includes(s2))
               {
                apiBaseUrl =API_BASE_URL + "/core/user/rest/user/loadbytokken";    
               }
               else
               {
                apiBaseUrl = API_BASE_URL+"/core/user/rest/user/loadbytokken";
               }


               var headers = {'Content-Type': 'application/json', 'tokken' :token }
               axios.get(apiBaseUrl,{headers: headers})
                   .then(res => {
                     reactLocalStorage.set('user_id_login',res.data.result.id);
                     reactLocalStorage.set('email_login',res.data.result.userName);
                    })
              
        
      
        
  
    }
componentWillMount(){
  var token=reactLocalStorage.get('accessToken');
  var ip=API_BASE_URL;
  var s2 = "localhost:3000";
  var apiBaseUrl;
  if(ip.includes(s2))
  {
   apiBaseUrl =API_BASE_URL + "/core/user/rest/advertisments/getAllAdv";
  }
  else
  {
   apiBaseUrl = API_BASE_URL+"/core/user/rest/advertisments/getAllAdv";
  }
  var headers = {'Content-Type': 'application/json', 'token' :token }
  axios.get(apiBaseUrl,{headers: headers})
      .then(res => {
        const persons = res.data.result.advertisments;
        if(persons !== undefined)
        {
          var array=[]
          var i;
          var value;
          for(i=0;i<persons.length;i++)
          {
            var ip=API_BASE_URL;
var s2 = "localhost:3000";
if(ip.includes(s2))
{
  value=persons[i].advertisment__src;
            array.push({url:"http://"+value})
}
else
{
  value=persons[i].advertisment__src.replace('192.168.100.9',window.location.origin)
            array.push({url:"http://"+value})
}
           
          }
         this.setState({image:array})
      
        }
        
      })  
}
    render(){
        return (
            <div className="big_div">
            <Menutest/>
            <div className="actionMenu">
            <div className="modal_ads">

        <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModal}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <h2 ref={subtitle => this.subtitle = subtitle}></h2>
          <br/>
          <div className="slider_auth">
          <div>
            <Carousel style={{width:'20%'}}
              arrowLeft={<Icon className="icon-example" type="left-circle" style={{ zoom:'2', padding: '3px'}}/>}
              arrowRight={<Icon className="icon-example" type="right-circle" style={{ zoom:'2' , padding: '3px'}}/>}
              addArrowClickHandler
            >
             { this.state.image.map(img =>
              <img src={img.url} className="slider_pic" alt="slider_pic"/>
             )}
            
            </Carousel>
          </div>
          </div>
          <Button  onClick={this.closeModal} className="close_btn">{i18n.t('Close.label')}</Button>

        </Modal>
</div>
            </div>
            </div>
        );
    }
}
const mapStateToProps = (state)=>{
    return {...state}
  }
  export default connect(mapStateToProps) (Landing);